import { Button, Col, DatePicker, Form, Input, Radio, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiLocation from "../../../../../../api/Participantes/api.location";
import { InputTexto } from "../../../../../../components/Mascaras/InputTexto/InputTexto";
import { useLocations } from "../../../../../../hooks/useLocations";
import { FormBeps } from "../../../../../../models/Beps/beps.model";
import { Municipio } from "../../../../../../models/LocationsModels/locations.models";
import getStorageUser from "../../../../../../middlewares/GetStorageUser"
import locale from 'antd/es/date-picker/locale/es_ES';
import { SexoOptions } from "../../../../../../utils/dataSelectOptions";

type DatosPersonalesProps = {
  formBeps: FormBeps;
  setFormBeps: Function;
  openDatePickerExpedicion: boolean;
  setOpenDatePickerExpedicion: Function;
  obtenerFechaDatePickerExpedicion: any;
  openDatePickerNacimiento: boolean;
  setOpenDatePickerNacimiento: Function;
  obtenerFechaDatePickerNacimiento: any;
  guardarFormulario: any;
  handleSearchDocument: any;
  tab: any;
  nextTab: any;
};
export const DatosPersonales = ({
  formBeps,
  setFormBeps,
  openDatePickerExpedicion,
  setOpenDatePickerExpedicion,
  obtenerFechaDatePickerExpedicion,
  openDatePickerNacimiento,
  setOpenDatePickerNacimiento,
  obtenerFechaDatePickerNacimiento,
  guardarFormulario,
  handleSearchDocument,
}: DatosPersonalesProps) => {
  let fields = [
    { name: "numero_documento", value: formBeps.numero_documento },
    { name: "tipo_agente", value: formBeps.tipo_agente },
    { name: "primer_nombre", value: formBeps.primer_nombre },
    { name: "segundo_nombre", value: formBeps.segundo_nombre },
    { name: "primer_apellido", value: formBeps.primer_apellido },
    { name: "segundo_apellido", value: formBeps.segundo_apellido },
    { name: "fecha_nacimiento", value: formBeps.fecha_nacimiento },
    { name: "fecha_nacimiento_dia", value: formBeps.fecha_nacimiento_dia },
    { name: "fecha_nacimiento_mes", value: formBeps.fecha_nacimiento_mes },
    { name: "fecha_nacimiento_año", value: formBeps.fecha_nacimiento_año },
    { name: "fecha_expedicion", value: formBeps.fecha_expedicion },
    { name: "fecha_expedicion_dia", value: formBeps.fecha_expedicion_dia },
    { name: "fecha_expedicion_mes", value: formBeps.fecha_expedicion_mes },
    { name: "fecha_expedicion_año", value: formBeps.fecha_expedicion_año },
    { name: "sexo", value: formBeps.sexo },
    {
      name: "departamento_nacimiento",
      value: formBeps.departamento_nacimiento,
    },
    { name: "municipio_nacimiento", value: formBeps.municipio_nacimiento },
    { name: "grupo_etnico", value: formBeps.grupo_etnico },
    {
      name: "departamento_residencia",
      value: formBeps.departamento_residencia,
    },
    { name: "municipio_residencia", value: formBeps.municipio_residencia },
  ];
  const { departamentos } = useLocations();
  const [municipios, setMunicipios] = useState<Municipio[]>([]);
  const [user, setUser] = useState({});
  const [disabledInput, setDisabledInput] = useState(true);
  const navigate = useNavigate();
  const handleDepartamento = async (departamento: string) => {
    try {
      const datosDepartamento = departamento.split("-");
      setFormBeps({
        ...formBeps,
        departamento_residencia: datosDepartamento[1],
        municipio_residencia: "",
      });
      const municipios = await apiLocation.obtenerMunicipios(
        datosDepartamento[0]
      );
      setMunicipios(municipios);
      setDisabledInput(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    obtenerusuario();
  }, []);
  const obtenerusuario = async () => {
    if (localStorage.user) {
      const user = getStorageUser()    
      setFormBeps({ ...formBeps, numero_documento: user.documento });
           
      handleSearchDocument(user.documento);
    } else {
      navigate("/login");
    }
  };
  
  return (
    <Form
      size="large"
      fields={fields}
      name="formDatosPersonales"
      onFieldsChange={(_, fields: any) => {
        let infoupdate: any = { ...formBeps };
        for (var i in fields) {
          infoupdate[fields[i].name] = fields[i].value;
        }
        setFormBeps(infoupdate);
      }}
      onFinish={guardarFormulario}
    >
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Documento de identidad
          </span>
          <Form.Item
            className="no-margin"
            name="numero_documento"
            rules={[{ required: true, message: "" }]}
          >
            <Input type="number" value={formBeps.numero_documento} />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Tipo de agente
          </span>
          <Form.Item
            className="no-margin"
            name="tipo_agente"
            rules={[{ required: true, message: "Selecciona un agente" }]}
          >
            <Radio.Group value={formBeps.tipo_agente}>
              <Radio value={1}>Soy creador</Radio>
              <Radio value={2}>Soy gestor</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Primer nombre
          </span>
          <Form.Item
            className="no-margin"
            name="primer_nombre"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <InputTexto
              maxLength={100}
              name="primer_nombre"
              texto={formBeps.primer_nombre}
              setTexto={setFormBeps}
              alltexto={formBeps}
              onInput={formBeps.primer_nombre}
            />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Segundo nombre -{" "}
            <span className="font-family-Montserrat-Regular font-size-10px">
              &nbsp;opcional
            </span>
          </span>
          <Form.Item className="no-margin" name="segundo_nombre">
            <InputTexto
              maxLength={100}
              name="segundo_nombre"
              texto={formBeps.segundo_nombre}
              setTexto={setFormBeps}
              alltexto={formBeps}
              onInput={formBeps.segundo_nombre}
            />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Primer apellido
          </span>
          <Form.Item
            className="no-margin"
            name="primer_apellido"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <InputTexto
              maxLength={100}
              name="primer_apellido"
              texto={formBeps.primer_apellido}
              setTexto={setFormBeps}
              alltexto={formBeps}
              onInput={formBeps.primer_apellido}
            />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Segundo apellido -{" "}
            <span className="font-family-Montserrat-Regular font-size-10px">
              &nbsp;opcional
            </span>
          </span>
          <Form.Item className="no-margin" name="segundo_apellido">
            <InputTexto
              maxLength={100}
              name="segundo_apellido"
              texto={formBeps.segundo_apellido}
              setTexto={setFormBeps}
              alltexto={formBeps}
              onInput={formBeps.segundo_apellido}
            />
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="row">
            <div
              className="col-11"
              style={{ display: "flex", flexDirection: "row", paddingRight: 0 }}
            >
              <div className="row g-2">
                <span className="width-100 pt-3">
                  Fecha de expedición del documento
                </span>

                <Row
                  gutter={[8, 0]}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Col span={6}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_expedicion_dia"
                      rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                      <Input
                        type="number"
                        min="1"
                        max="31"
                        maxLength={2}
                        value={formBeps.fecha_expedicion_dia}
                        placeholder="DD"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_expedicion_mes"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Input
                        type="number"
                        min="1"
                        max="12"
                        maxLength={2}
                        value={formBeps.fecha_expedicion_mes}
                        placeholder="MM"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={11}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_expedicion_año"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Input
                        type="number"
                        maxLength={4}
                        value={formBeps.fecha_expedicion_año}
                        placeholder="AAAA"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <DatePicker
                      className="font-size-20px font-color-051923bf"
                      clearIcon={false}
                      onClick={() => setOpenDatePickerExpedicion(true)}
                      bordered={false}
                      open={openDatePickerExpedicion}
                      onChange={obtenerFechaDatePickerExpedicion}
                      locale={locale}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <div className="row">
            <div
              className="col-11"
              style={{ display: "flex", flexDirection: "row", paddingRight: 0 }}
            >
              <div className="row g-2">
                <span className="width-100 pt-3">Fecha de nacimiento</span>

                <Row
                  gutter={[8, 0]}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Col span={6}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_nacimiento_dia"
                      rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                      <Input
                        type="number"
                        min="1"
                        max="31"
                        maxLength={2}
                        value={formBeps.fecha_nacimiento_dia}
                        placeholder="DD"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_nacimiento_mes"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Input
                        type="number"
                        min="1"
                        max="12"
                        maxLength={2}
                        value={formBeps.fecha_nacimiento_mes}
                        placeholder="MM"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={11}>
                    <Form.Item
                      className="no-margin"
                      name="fecha_nacimiento_año"
                      rules={[{ required: true, message: "" }]}
                    >
                      <Input
                        type="number"
                        maxLength={4}
                        value={formBeps.fecha_nacimiento_año}
                        placeholder="AAAA"
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    <DatePicker
                      className="col-1 no-margin font-size-20px font-color-051923bf"
                      clearIcon={false}
                      onClick={() => setOpenDatePickerNacimiento(true)}
                      bordered={false}
                      open={openDatePickerNacimiento}
                      onChange={obtenerFechaDatePickerNacimiento}
                      locale={locale}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Grupo étnico
          </span>
          <Form.Item
            className="no-margin"
            name="grupo_etnico"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Select placeholder="Seleccionar..." value={formBeps.grupo_etnico}>
              <Select.Option value={1}>Ningúno</Select.Option>
              <Select.Option value={2}>Gitano/ROM</Select.Option>
              <Select.Option value={3}>Comunidad Raizal</Select.Option>
              <Select.Option value={4}>Comunidad Palenquera</Select.Option>
              <Select.Option value={5}>
                Comunidad Negra y Afrodescendiente
              </Select.Option>
              <Select.Option value={6}>Indigena</Select.Option>
            </Select>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Departamento de residencia
          </span>
          <Form.Item
            className="no-margin"
            name="departamento_residencia"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Select
              placeholder="Seleccionar..."
              value={formBeps.departamento_residencia}
              onChange={(e) => handleDepartamento(e)}
            >
              {departamentos.map(({ id, nombre }) => (
                <Select.Option key={id} value={`${id}-${nombre}`}>
                  {nombre}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Municipio de residencia
          </span>
          <Form.Item
            className="no-margin"
            name="municipio_residencia"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Select
              placeholder="Seleccionar..."
              value={formBeps.municipio_residencia}
              disabled={disabledInput}
            >
              {municipios.map(({ id, nombre }) => (
                <Select.Option key={id} value={id}>
                  {nombre}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="col-12 col-md-6 col-lg-3 mt-3 mb-3">
          <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
            Sexo
          </span>
          <Form.Item
            className="no-margin"
            name="sexo"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Select
              placeholder="Seleccionar..."
              value={formBeps.sexo}
            >
               {SexoOptions.map(({ value, text }) => (
                  <Select.Option key={`SEXO-${value}`} value={value}>
                    {text}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </div>
      </div>
      <div className="no-margin" style={{ position: "sticky", bottom: 0 }}>
        <div className="col justify-content-flex-end">
          <Button
            className="button-azul-radius"
            form="formDatosPersonales"
            htmlType="submit"
          >
            Guardar y continuar
          </Button>
        </div>
      </div>
    </Form>
  );
};
